import { locationInputSchema } from '@/lib/validation/input/location-schema'
import { z } from 'zod'
import { filterableStateSchema } from '../base'

// -------------------------
// Locations State Validation
// -------------------------
export const locationStateItemSchema = locationInputSchema.extend({
  isSelected: z.boolean().optional()
})

export const locationStateSchema = filterableStateSchema.extend({
  items: z.array(locationStateItemSchema),
  selectedLocation: locationStateItemSchema.nullable()
})

export const locationActionValidation = {
  'locations/setLocations': z.array(locationStateItemSchema),
  'locations/updateLocation': locationStateItemSchema,
  'locations/setSelectedLocation': locationStateItemSchema
} as const

// Type inference helpers
export type LocationStateValidation = z.infer<typeof locationStateSchema>
